module.exports = __webpack_public_path__ + "static/media/md-pin.a3f117f0.svg";